import { render, staticRenderFns } from "./NewsLifecycle.vue?vue&type=template&id=83fb9cd8&scoped=true"
import script from "./NewsLifecycle.vue?vue&type=script&lang=js"
export * from "./NewsLifecycle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83fb9cd8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Projekte\\Onlytonapoli\\onlytonapoliapp\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('83fb9cd8')) {
      api.createRecord('83fb9cd8', component.options)
    } else {
      api.reload('83fb9cd8', component.options)
    }
    module.hot.accept("./NewsLifecycle.vue?vue&type=template&id=83fb9cd8&scoped=true", function () {
      api.rerender('83fb9cd8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/news/NewsLifecycle.vue"
export default component.exports